export default __webpack_public_path__ + "static/media/arrowRight.09f99761.svg";